module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-B"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pgContent"
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "accept": ".doc,.docx",
      "headers": _vm.postHead,
      "disabled": _vm.upStateHybg == 'loading',
      "action": _vm.postUrl,
      "before-upload": _vm.prevCtrls1,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "on-remove": _vm.removeCtrls,
      "show-file-list": false,
      "data": {
        fileProperty: 1
      },
      "multiple": "",
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', [(_vm.upStateHybg == 'loaded' || _vm.ableUpZgbg == 2) ? _c('span', [_vm._v("更新分析报告")]) : (_vm.upStateHybg == 'loading') ? _c('span', [_vm._v("上传中 "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('span', [_vm._v("上传分析报告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flieList",
    attrs: {
      "download": ""
    }
  }, [_c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.fileUrlHybg)
      }
    }
  }, [_vm._v(_vm._s(_vm.fileNameHybg))])]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    attrs: {
      "accept": ".doc,.docx",
      "headers": _vm.postHead,
      "disabled": _vm.upStateZgbg == 'loading',
      "action": _vm.postUrl,
      "before-upload": _vm.prevCtrls2,
      "on-progress": _vm.pgressCtrls,
      "on-error": _vm.errorCtrls,
      "on-success": _vm.successCtrls,
      "on-remove": _vm.removeCtrls,
      "show-file-list": false,
      "data": {
        fileProperty: 2
      },
      "multiple": "",
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', [(_vm.upStateZgbg == 'loaded' || _vm.ableUpZgbg == 2) ? _c('span', [_vm._v("更新整改报告")]) : (_vm.upStateZgbg == 'loading') ? _c('span', [_vm._v("上传中 "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('span', [_vm._v("上传整改报告")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flieList"
  }, [_c('a', {
    attrs: {
      "download": ""
    },
    on: {
      "click": function($event) {
        _vm.goUrl(_vm.fileUrlZgbg)
      }
    }
  }, [_vm._v(_vm._s(_vm.fileNameZgbg))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "15px",
      "line-height": "20px",
      "color": "black"
    }
  }, [_vm._v("\n      上传文件格式为doc、docx，文件大小不超过10M\n    ")]), _vm._v(" "), _c('div', [_c('el-progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upStateHybg == 'loading' || _vm.upStateZgbg == 'loading'),
      expression: "upStateHybg == 'loading' || upStateZgbg == 'loading'"
    }],
    staticClass: "progressBox",
    attrs: {
      "stroke-width": 9,
      "percentage": _vm.percentage
    }
  })], 1), _vm._v(" "), (_vm.ableUpHybg == 3) ? _c('div', {
    staticClass: "pvcTips"
  }, [_vm._v("已上报至总局")]) : _vm._e()], 1), _vm._v(" "), (_vm.ableUpHybg == 1) ? _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goAdmin
    }
  }, [_vm._v("上报国家新闻出版署")])], 1) : _vm._e(), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("上报国家新闻出版署")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "20px"
    }
  }, [_vm._v("若省局已经审核完成，请点击“上报国家新闻出版署”。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black",
      "font-size": "14px"
    }
  }, [_vm._v("音像电子出版单位年度核验情况报告等材料（含各社登记表）报送方式：")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "black",
      "font-size": "14px"
    }
  }, [_vm._v("由省级出版行政管理部门统一寄送至以下地址，北京市西城区宣武门外大街40号出版局音像电子处，联系人：郑加可，电话010-83138687")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7521d2ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/Audio_Elect/commonReport.vue
// module id = 1776
// module chunks = 1